import { Component, Input, OnChanges } from '@angular/core'
import { Device } from '../../models'

@Component({
  selector: 'device-card',
  templateUrl: './device-card.component.html'
})
export class DeviceCardComponent implements OnChanges {
  @Input() public device: Device

  public ngOnChanges () {}
}
